import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';
import { Icon } from '@src-common/view/components/Icon';

import s from './Feedback.module.css';

const Feedback = () => {
  const links = useExternalLinks();

  const [isClosed, setIsClosed] = useState(JSON.parse(localStorage?.isFeedBackClosed ?? 'false'));
  const handleClose = useCallback(() => {
    if (localStorage) {
      localStorage.isFeedBackClosed = true;
    }

    setIsClosed(true);
  }, []);

  return isClosed ? null : (
    <div className={s.feedback}>
      <button className={s.close} onClick={handleClose}>
        <Icon icon="cross" />
      </button>
      <FormattedMessage
        defaultMessage="We have launched a new version of the dashboard. Please, share your feedback so we can keep improving it."
        id="ofJcRS"
      />
      <a className={s.button} target="_blank" href={links.shareFeedback} rel="noreferrer noopener">
        <FormattedMessage defaultMessage="share feedback" id="14TaGy" />
        <Icon icon="arrow-to-end-in-circle" />
      </a>
    </div>
  );
};

export { Feedback };
